export const TEXTAREA_CONFIG = {
  lineHeight: 24,
  maxLines: 5,
  padding: 16,
} as const;

export interface AutoExpandingTextareaConfig {
  lineHeight: number;
  maxLines: number;
  padding: number;
}
